import {Component, Input, OnInit, ViewChild, ChangeDetectionStrategy} from "@angular/core";
import {
    IPortfolioResultResponse,
    PrActionState
} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";
import {IrbDialogsEvents, IrbRebalanceEvents} from '@irb-common/events';
import {IApplyFilterOnLanding} from '@irb/app.model';
import {AppService} from '@irb/app.service';
import {DialogComponent} from "@irb-common/components/dialog/dialog.component";
import {DialogPrManualAdjustmentComponent} from "@irb/irb-dialogs/dialog-pr-manual-adjustment/dialog-pr-manual-adjustment.component";
import { IrbAuthenticationService } from "@irb/irb-authentication/irb-authentication.service";
import {PrApplicationService} from '@irb/irb-editors/editor-portfolio-result/services';

@Component({ standalone: false,
    selector: "irb-com-pr-action-panel",
    templateUrl: "./com-pr-action-panel.component.html",
    styleUrls: ["./com-pr-action-panel.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComPrActionPanelComponent implements OnInit{
    @ViewChild("dialog") dialog: DialogComponent;
    @Input()
    data: IPortfolioResultResponse;

    @Input()
    state: PrActionState;

    @Input()
    isModified: boolean;
    isTrader:boolean;

    @Input()
    isAutomated: boolean;
    
    constructor(private as: AppService, public ias :IrbAuthenticationService, private pras: PrApplicationService) {}

    ngOnInit(){
        this.ias.getAppConfigDetails().subscribe((data: any) => {
            this.isTrader = data.isTrader;
          });
    }

    viewAuditTrail() {
        this.as.fireEvent(IrbDialogsEvents.SHOW_PR_AUDIT, this.isModified ? null : {
            portfolioName: this.data.portfolioName,
            rebalId: this.data.rebalId,
            portfolioId: this.data.portfolioId
        });
    }

    viewOrdersOnBlotter() {
            const state: IApplyFilterOnLanding = {
                tabname: (this.isAutomated) ? 'Automated' : 'Active',
                isUpdatRequired: true,
                filterModels: [
                    { name: 'rebalanceResultId', filter: this.data.rebalId.toString(), isUpdatRequired: true },
                    { name: 'portfolioName', filter: this.data.portfolioName.toString(), isUpdatRequired: true }
                ]
            } as IApplyFilterOnLanding;
        
            this.as.fireEvent(IrbRebalanceEvents.NAVIGATE_FROM_PORTFOLIO_RESULT_DETAIL, {
                path: '/orders/order-blotter',
                state: state
            });
    }
    
    runManualAdjustmentDialog(event: any) {
        false && console.log(event);
        const config = this.dialog.getDefaultConfig();
        config.minHeight = "100px";
        config.height = "auto";
        config.width = "850px";
        config.data = this.isModified ? null : {
            rebalanceName: this.data.rebalanceName,
            portfolioName: this.data.portfolioName,
            rebalId: this.data.rebalId,
            portfolioId: this.data.portfolioId,
            tradeExplanation: this.data.tradeExplanation || ''
        };
        this.dialog.open(DialogPrManualAdjustmentComponent, config);
    }
}
